import { Spin } from "antd";

import { styled } from "../../styles";

export const ProtocolListContainer = styled("div", {
  display: "flex",
  position: "relative",
  flexDirection: "column",
});

export const ProtocolListTableContainer = styled("div", {
  marginTop: "$4",

  height: "calc(100vh - 200px)",
  maxHeight: "800px",
});

// Same inset as the Published icon on the Workflows list.
export const PublishedCell = styled("div", {
  marginLeft: "30px",
});

export const FullscreenSpin = styled(Spin, {
  ".ant-spin-dot": {
    ".ant-spin-dot-item": {
      backgroundColor: "var(--colors-portal-loading-state-color)",
    },
  },
});

export const AddProtocolButton = styled("div", {
  color: "$charcoal",
  fontWeight: "600",
  fontSize: "12px",
  lineHeight: "17px",
  cursor: "pointer",
  position: "absolute",
  top: "14px",
  right: "10px",
  borderRadius: "6px",
  padding: "0 2px",

  "&:hover": {
    color: "var(--colors-portal-small-add-button-hover)",
  },
});
